<template>
  <v-container fluid>
    <v-row dense class="mb-3">

      <v-col class="12" sm="6" md="3" >
        <v-card elevation="2" outlined tile color="orange lighten-1" @click="snedMesaAyuda('MA:Solicitado')">
          <v-list-item two-line>
            <v-list-item-icon class="mr-2">
              <v-icon class="mdi-48px" color="white">mdi-file-document-multiple</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle class="font-weight-bold black--text subtitle-1">Mesa Ayuda No Asignados</v-list-item-subtitle>
              <v-list-item-title class="text-h4">{{indicadores.MASolictud}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>

      <v-col class="12" sm="6" md="3" >
        <v-card elevation="2" outlined tile color="lime darken-3" @click="snedMesaAyuda('MA:Asignado')">
          <v-list-item two-line>
            <v-list-item-icon class="mr-2">
              <v-icon class="mdi-48px" color="white">mdi-account-cog</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle class="font-weight-bold black--text subtitle-1">Mesa Ayuda Activos</v-list-item-subtitle>
              <v-list-item-title class="text-h4">{{indicadores.MAActivos}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>

      <v-col class="12" sm="6" md="3" >
        <v-card elevation="2" outlined tile color="blue lighten-2" @click="snedMesaAyuda('SE:EntradaServicio')">
          <v-list-item two-line>
            <v-list-item-icon class="mr-2">
              <v-icon class="mdi-48px" color="white">mdi-file-document-multiple</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle class="font-weight-bold black--text subtitle-1">Servicio Equipos No Asignados</v-list-item-subtitle>
              <v-list-item-title class="text-h4">{{indicadores.SEEntrada}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>

      <v-col class="12" sm="6" md="3" >
        <v-card elevation="2" outlined tile color="light-green darken-2" @click="snedMesaAyuda('SE:Asignado')">
          <v-list-item two-line>
            <v-list-item-icon class="mr-2">
              <v-icon class="mdi-48px" color="white">mdi-account-cog</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle class="font-weight-bold black--text subtitle-1">Servicio Equipo Activos</v-list-item-subtitle>
              <v-list-item-title class="text-h4">{{indicadores.SEActivos}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>

    </v-row>

    <v-row dense class="mb-3">
      <v-layout justify-center>
        <v-flex sm12>
          <v-toolbar color="primary" dark>
            <v-row dense class="pt-6">
              <v-col cols="12" sm="8">
                <v-row dense>
                  <v-col cols="3">
                    <DatePicker :setterModel="dates.fInicial" :itemAction="fieldInit" :on-success="actionFieldData"/>
                  </v-col>
                  <v-col cols="3">
                    <DatePicker :setterModel="dates.ffinal" :itemAction="fieldFinal" :on-success="actionFieldData"/>
                  </v-col>
                  <v-col cols="3">
                    <v-btn tile color="success" @click="searchByDates">
                      <v-icon left> mdi-calendar-search </v-icon> Buscar </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-toolbar>

          <v-card tile>
            <v-card-text>
              <v-row dense>
                <v-col cols="12">
                  <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
                </v-col>
                <v-col cols="12" sm="6">
                  <ChartBar :object="tipoAtencionObject" :data="tipoAtencionData" :on-success="successAction" textAction= "tipoAtencionEvent" />
                </v-col>
                <v-col cols="12" sm="6">
                  <ChartBar :object="estatusObject" :data="estatusData" />
                </v-col>

                <v-col cols="12" sm="6">
                  <ChartPie2D :object="mesaAyudaObject" :data="mesaAyudaData" />
                </v-col>
                <v-col cols="12" sm="6">
                  <ChartPie2D :object="equiposServiciosObject" :data="equiposServiciosData" />
                </v-col>

              </v-row>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-row>

  </v-container>
</template>
<!-- doughnut2d -->
<script>
import { mapActions, mapGetters } from 'vuex'
import ChartBar from '@/components/charts/ChartBar'
import ChartPie2D from '@/components/charts/ChartPie2D'

import DataTableMain from '@/components/dataTableMain'
import DatePicker from '@/components/fields/DatePicker'
import router from '@/router'
export default {
  data: (m) => ({
    table: {
      modelMain: [],
      showSelect: false,
      singleSelect: true,
      header: {
        options: [],
        titles: [
          { text: 'Nombre', value: 'nombrecompleto', class: 'black--text' },
          { text: 'Usuario', value: 'usuario', class: 'black--text' },
          { text: 'Departamento', value: 'departamento', class: 'black--text' },
          { text: 'Pendiente Mesa Ayuda', value: 'pendienteMA', class: 'black--text', align: 'center' },
          { text: 'Total Mesa Ayuda', value: 'totalMA', class: 'black--text', align: 'center' },
          { text: 'Pendiente Taller Equipos', value: 'pendienteSE', class: 'black--text', align: 'center' },
          { text: 'Total Taller Equipos', value: 'totalSE', class: 'black--text', align: 'center' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    },
    fieldInit: {
      name: 'Fecha Inicial',
      nameid: 'fInicial'
    },
    fieldFinal: {
      name: 'Fecha Final',
      nameid: 'ffinal'
    },
    dates: {
      fInicial: null,
      ffinal: null
    },

    indicadores: {
      MASolictud: 0,
      MAActivos: 0,
      SEEntrada: 0,
      SEActivos: 0
    },
    mesaAyudaObject: {
      caption: 'Solicitudes de Mesa de Ayuda',
      subCaption: 'Tipo de Actividades por Estatus Realizado',
      numberPrefix: 'C. ',
      showPercentInTooltip: '0',
      decimals: '1',
      useDataPlotColorForLabels: '1',
      animateClockwise: '1',
      theme: 'fusion'
    },
    mesaAyudaData: [],

    equiposServiciosObject: {
      caption: 'Solicitudes de Equipos en Taller',
      subCaption: 'Tipo de Actividades por Estatus Realizado',
      numberPrefix: 'Cant. ',
      showPercentInTooltip: '0',
      decimals: '1',
      useDataPlotColorForLabels: '1',
      theme: 'fusion'
    },
    equiposServiciosData: [],

    tipoAtencionObject: {
      caption: 'Tipo de Atención Solicitada',
      subCaption: 'Solicitudes con mayor frecuencia',
      showPercentInTooltip: '0',
      decimals: '1',
      useDataPlotColorForLabels: '1',
      theme: 'fusion'
    },
    tipoAtencionData: [],

    estatusObject: {
      caption: 'Estatus de Equipos Atendidos',
      subCaption: 'Equipos reparados con estatus',
      showPercentInTooltip: '0',
      decimals: '1',
      useDataPlotColorForLabels: '1',
      theme: 'fusion'
    },
    estatusData: []
  }),
  components: {
    DataTableMain,
    DatePicker,
    ChartBar,
    ChartPie2D
  },
  mounted () {
    this.getDataUrl('dashboard.graficas-seguimiento')
  },
  methods: {
    ...mapActions(['getUrlServices', 'urlPostServicesAction']),
    // *==========*==========*==========*==========*==========*==========* \\
    getDataUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.urlPostServicesAction({ url: router, data: this.dates })
      } else {
        this.getUrlServices()
      }
    },
    successAction (item) {
      this[item.action](item)
    },

    tableAction (item) {
      this[item.action](item)
    },
    actionFieldData (obj) {
      this.dates[obj.id] = (obj.data === undefined) ? null : obj.data
    },
    tipoAtencionEvent (item) {
      console.log(item)
    },
    searchByDates () {
      this.getDataUrl('dashboard.graficas-seguimiento')
    },
    snedMesaAyuda (exprecion) {
      router.push({ name: 'MeAyuSolicitudes', params: { exprecion: exprecion } })
    },
    saveCaracteristicas (model) {
      console.log('model', model)
    },
    closeDialog (model) {}
  },
  computed: {
    ...mapGetters(['get_urls', 'get_object'])
  },
  watch: {
    get_urls (val) {
      if (val) {
        this.getDataUrl('dashboard.graficas-seguimiento')
      }
    },
    get_object (val) {
      if (val) {
        this.table.body.data = val.tableUser
        this.mesaAyudaData = val.graf1
        this.equiposServiciosData = val.graf2
        this.tipoAtencionData = val.tipoAtencion
        this.estatusData = val.tablestatus

        if (val.dafault === 'si') {
          this.dates.fInicial = val.init
          this.dates.ffinal = val.final
        }
        this.indicadores = val.indicadorEstatusActivos
      }
    }
  }
}
</script>
<style>
</style>
